var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLearner)?_c('a',{staticClass:"navbar-item",on:{"click":_vm.LogIntoSis}},[_vm._v(" Log into SIS "),(_vm.loading)?_c('genexMiniLoader',{staticClass:"ml-2"}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }